export const isDevGetter = "is Dev getter";

export const canEnterClassGetter = "canEnterClassGetter";
export const isUserBlockedGetter = "isUserBlockedGetter";
